var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"scrollToTop",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fas fa-angle-up"})]),_c('div',{staticClass:"overlay"})])
}]

export { render, staticRenderFns }